export default function TestimonialsCTA() {
  const handleClick = () => {
    const el = document.getElementById('membership-tiers');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-emerald-700 via-emerald-600 to-teal-600 relative overflow-hidden">
      {/* Decorative background circles */}
      <div className="absolute -top-20 -left-20 w-80 h-80 bg-white/5 rounded-full pointer-events-none"></div>
      <div className="absolute -bottom-24 -right-16 w-96 h-96 bg-white/5 rounded-full pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/3 rounded-full pointer-events-none"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center text-white">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 bg-white/15 border border-white/25 rounded-full px-5 py-2 mb-8 text-sm font-semibold tracking-widest uppercase">
          <i className="ri-star-fill text-amber-300"></i>
          Join 5,000+ Successful Students
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-5xl font-bold mb-5 leading-tight">
          Their Success Can Be <span className="text-amber-300">Yours Too</span>
        </h2>

        {/* Sub-headline */}
        <p className="text-xl md:text-2xl text-white/85 max-w-3xl mx-auto leading-relaxed mb-10">
          Every story you just read started with one decision — choosing the right materials.
          Pick a membership plan and get instant access to everything that made those results possible.
        </p>

        {/* Trust bullets */}
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {[
            { icon: 'ri-shield-check-line', text: '30-Day Money-Back Guarantee' },
            { icon: 'ri-lock-line', text: 'Secure & Instant Access' },
            { icon: 'ri-refresh-line', text: 'Cancel Anytime' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 bg-white/10 rounded-full px-5 py-2.5 text-sm font-medium">
              <i className={`${item.icon} text-amber-300 text-base`}></i>
              {item.text}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={handleClick}
          className="inline-flex items-center gap-3 bg-amber-400 hover:bg-amber-300 text-gray-900 font-bold text-lg px-12 py-5 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 active:scale-95 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-vip-crown-line text-xl"></i>
          Choose Your Membership Plan
          <i className="ri-arrow-down-line text-xl"></i>
        </button>

        <p className="mt-5 text-white/60 text-sm">
          Plans starting at <strong className="text-white">$19/month</strong> · Lifetime options available
        </p>
      </div>
    </section>
  );
}
